import {
    BASE_URL, 
    USER_CONSENT,
    PATCH
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const submitUserConsent = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${USER_CONSENT}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      //body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  
  